export const ActionTypes = {
    CHANGE_LANGUAGE: "CHANGE_LANGUAGE",
};